<template>
  <div :class="$style['footer']">
    <!-- 底部导航 -->
    <div :class="$style['footer-navs']">
      <a v-for="nav in navItems" :key="nav.id" :href="nav.url" target="_blank">
        <img :src="nav.image" />
        <span>{{ nav.title }}</span>
      </a>
    </div>

    <!-- Logo和法律信息 -->
    <div :class="$style['footer-info']">
      <div :class="$style['footer-info-content']">
        <!-- Logo -->
        <div :class="$style['footer-logo']">
          <img :src="logoVerticalWhiteRed" />
        </div>

        <div :class="$style['footer-legal']">
          <!-- 法律相关协议 -->
          <div :class="$style['footer-legal-links']">
            <a
              v-for="link in legalLinks"
              :key="`link-${link.id}`"
              :href="link.url"
              target="_blank"
            >
              {{ link.title }}
            </a>
          </div>

          <!-- 许可证 -->
          <div :class="$style['footer-legal-license']">
            <a
              v-for="license in licenseInfo"
              :key="`license-${license.id}`"
              :href="license.url || undefined"
              :target="license.url ? '_blank' : undefined"
            >
              <img v-if="license.icon" :src="license.icon" />
              {{ license.title }}
            </a>
          </div>

          <!-- 版权信息 -->
          <div :class="$style['footer-legal-copyright']">
            {{ copyright }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LandingFooter',
  computed: {
    ...mapGetters([
      'licenseInfo',
      'copyright',
      'logoVerticalWhiteRed',
      'footLinks',
    ]),
    navItems() {
      return this.footLinks.navLinks
    },
    legalLinks() {
      return this.footLinks.legalLinks
    },
  },
}
</script>

<style lang="less" module>
.footer {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &-navs {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.75rem;
    padding: 0 0.4rem;

    a {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 0.2rem;
      font-size: 0.28rem;
      font-weight: 700;
      color: @text-color;
      text-decoration: none;

      img {
        .size(0.64rem);

        object-fit: contain;
      }

      &:hover {
        color: @primary;
      }
    }
  }

  &-info {
    background-color: #171515;

    &-content {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 1920px;
      margin: 0 auto;
    }
  }

  &-logo {
    img {
      .size(1.64rem, 1.31rem);
    }
  }

  &-legal {
    font-size: 0.2rem;
    line-height: 1.8;

    &,
    a {
      color: #b4b4b4;
    }

    a {
      text-decoration: none;

      &[href]:hover {
        text-decoration: underline;
      }
    }

    &-links {
      display: flex;
      align-items: center;
      gap: 0.1rem;

      a {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.1rem;
        font-size: 0.24rem;
        font-weight: 700;

        &:not(:last-child)::after {
          content: '|';
          display: inline-block;
        }
      }
    }

    &-license {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0 0.1rem;

      a {
        display: flex;
        align-items: center;
        gap: 0.02rem;
      }

      img {
        .size(0.2rem);

        object-fit: contain;
      }
    }
  }
}

// 横屏
:global(.landing-screen-landscape) {
  .footer {
    &-navs {
      gap: 1.45rem;
    }

    &-info {
      padding: 0.8rem 0.4rem;

      &-content {
        gap: 0.78rem;
      }
    }
  }
}

// 竖屏
:global(.landing-screen-portrait) {
  .footer {
    &-navs {
      gap: 0.5rem;
    }

    &-info {
      padding: 0.4rem 1.5rem;

      &-content {
        flex-direction: column;
        gap: 0.45rem;
      }
    }

    &-legal {
      text-align: center;

      &-links {
        justify-content: center;
      }

      &-license {
        justify-content: center;
      }
    }
  }
}
</style>
